import { createApp } from 'vue'
import { QUESTIONS, RESULT_SLUGS } from './constants.js'
import { getResultSlug } from './logics.js'
import FStepIndicator from '~/js/components/stepIndicator'
const ID_PAGE_COLOR_ANALYSIS = 'js-pageColorAnalysis'

document.addEventListener('DOMContentLoaded', () => {
  const elementPageColorAnalysis = document.getElementById(
    ID_PAGE_COLOR_ANALYSIS
  )
  if (!elementPageColorAnalysis) return
  const hash = window.location.hash?.replace('#', '')
  const baseUrlBlog = elementPageColorAnalysis.dataset.baseUrlBlog
  if (Object.values(RESULT_SLUGS).includes(hash))
    window.location.href = `${baseUrlBlog}/${hash}`

  createApp({
    name: 'PagesColorAnalysis',
    components: { FStepIndicator },
    data() {
      return {
        currentStep: 0,
        isSending: false,
        isQuestionShow: false,
        selectedAnswers: QUESTIONS.map(() => ''),
      }
    },
    computed: {
      isAnswerCompleted() {
        return this.selectedAnswers.every((answer) => answer)
      },
      isAnsweredArray() {
        return this.selectedAnswers.map((answer) => !!answer)
      },
      questions() {
        return QUESTIONS
      },
      stepTexts() {
        return this.questions.map((_, index) => `Q${index + 1}`)
      },
    },
    methods: {
      showResult() {
        this.isSending = true
        const resultTerm = getResultSlug(this.selectedAnswers)
        setTimeout(() => {
          window.location.href = `${baseUrlBlog}/${resultTerm}`
        }, 3000)
      },
      onAnswerChanged(index) {
        this.currentStep = index + 1 < QUESTIONS.length ? index + 1 : null
        this.scrollTo()
      },
      onStepClicked(index) {
        if (index >= 0 && index < QUESTIONS.length) this.currentStep = index
        this.scrollTo()
      },
      scrollTo() {
        const targetRef = Number.isInteger(this.currentStep)
          ? `question${this.currentStep}`
          : 'show-result-button'
        const elementTarget = this.$refs[targetRef].length
          ? this.$refs[targetRef][0]
          : this.$refs[targetRef]

        elementTarget.scrollIntoView({
          behavior: 'smooth',
        })
      },
    },
  }).mount(elementPageColorAnalysis)
})
